module.exports = __webpack_public_path__ + "static/media/CoresPilates.1e462077.svg";